/**
 * QueueTourOverlay — Test Queue specific tour wrapped around the
 * shared TourOverlay component (iter145e). Steps preserved verbatim
 * from the original iter145d implementation.
 */
import TourOverlay from "@/components/TourOverlay";

const STEPS = [
  {
    id: "filters",
    selector: '[data-testid="test-queue-filters"]',
    placement: "below",
    title: "Filter chips",
    body: "Click these to narrow the list by status. The URL updates as you go, so you can deep-link to a saved filter.",
  },
  {
    id: "actions",
    selector: '[data-testid="test-queue-add-manual"]',
    placement: "below-end",
    title: "Manual entry & sync",
    body: "Super-admin only. Use Sync to pull in user requests + iterations, or Add to drop in a one-off entry like a deletion.",
    optional: true,
  },
  {
    id: "severity",
    selector: '[data-testid^="test-queue-severity-"]',
    placement: "right",
    title: "Severity ribbon",
    body: "RED = critical (deploy-mover), AMBER = moderate, SLATE = polish. Triage from top down: red → amber → slate.",
    optional: true,
  },
  {
    id: "approve",
    selector: '[data-testid^="test-queue-approve-"]',
    placement: "above",
    title: "Approve / Add improvement",
    body: "Approve clears the deploy gate. Add improvement files a child request engineering must address before the item returns to your queue.",
    optional: true,
  },
  {
    id: "done",
    selector: null,
    placement: "center",
    title: "You're set.",
    body: "Click Got it to dismiss this tour. Re-trigger it any time by clearing your browser site data or calling localStorage.removeItem('test_queue_tour_seen_v1').",
  },
];

export default function QueueTourOverlay() {
  return (
    <TourOverlay
      storageKey="test_queue_tour_seen_v1"
      bannerTitle="First time here?"
      bannerCopy="Take the 60-second tour — we'll walk you through the queue page in five quick steps."
      bannerTone="emerald"
      testIdPrefix="test-queue-tour"
      steps={STEPS}
    />
  );
}
